import { createContext, useMemo, useReducer } from 'react'
import defaultLexicon from '../lexicon/default'
import customLexicon from '../lexicon/customLexicon'

const LexiconContext = createContext()

function reducer(state, action) {
  switch (action.type) {
    case 'SET_LEXICON':
      const id = action.orgId.toString()
      const orgLexicon = customLexicon[id] ? customLexicon[id]  : defaultLexicon
      return { ...defaultLexicon, ...orgLexicon }

    default:
      throw new Error('error handling lexicon reducer')
  }
}

const LexiconContextProvider = ({ children }) => {
  const [lexicon, dispatch] = useReducer(reducer, defaultLexicon)

  const contextValues = useMemo(() =>
    ({ lexicon, dispatch }), [lexicon, dispatch])

  return (
    <LexiconContext.Provider value={contextValues}>
      {children}
    </LexiconContext.Provider>
  )
}

export { LexiconContext, LexiconContextProvider }
